import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { DataGridComponent, NoAutomationComponent } from '@fitness-force/grid';
import { AgeCellComponent, RouteStateService, StaffInfoComponent } from '@fitness-force/shared';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CampaignService } from 'libs/api/src/lib/campaign/campaign.service';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { OverlayModule } from 'primeng/overlay';
import { PopoverModule } from 'primeng/popover';
import { StyleClassModule } from 'primeng/styleclass';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { Observable, BehaviorSubject } from 'rxjs';
import { CampaignNameComponent } from '../../campaign-name/campaign-name.component';
import { Automation, CustomAutomationData, TENANTSINTERFACE } from '@fitness-force/models';
import { TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { CampaignStatusComponent } from '../../campaign-status/campaign-status.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CustomAutomationPopupComponent } from '../custom-automation-popup/custom-automation-popup.component';
import { AutomationEventType, OwnershipLevel } from '@fitness-force/enum';
import { SelectAutomationEventPopupComponent } from '../select-automation-event-popup/select-automation-event-popup.component';
import { SkeletonModule } from 'primeng/skeleton';
import { ToastMessageService } from 'libs/api/src/lib/toastmessage/toastmessage.service';

@Component({
  selector: 'fitness-force-automation-list',
  templateUrl: './automation-list.component.html',
  styleUrls: ['./automation-list.component.css'],
  providers: [DialogService],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    ToggleSwitchModule,
    InputTextModule,
    IconFieldModule,
    InputIconModule,
    SelectModule,
    EditorModule,
    ButtonModule,
    FileUploadModule,
    OverlayModule,
    PopoverModule,
    CheckboxModule,
    TableModule,
    AvatarModule,
    StyleClassModule,
    TagModule,
    TagModule,
    AvatarModule,
    StyleClassModule,
    SkeletonModule,
    DataGridComponent,
    TranslateModule,
    RouterModule
]
})
export class AutomationListComponent  implements OnInit {
  getAccessTenantList$: Observable<any> = new Observable();
  tenantId = 0;
  tenantFranchiseId = 0;
  tenant!: any;
  showSkeleton$ = new BehaviorSubject(true);
  selectAllData = new BehaviorSubject(false);
  emptyStateComponent$ = new BehaviorSubject<any>(NoAutomationComponent);
  tableData = new BehaviorSubject<Automation[]>([]);
  columns: any = new BehaviorSubject([]);
  loading = new BehaviorSubject<boolean>(false);
  staffList:any;
  Params: any = new Map();
  searchText: string = '';
  automationList = new BehaviorSubject<Automation[]>([]);
  refAutomationModal: DynamicDialogRef = {} as DynamicDialogRef;
  refEventTrigeersModal: DynamicDialogRef = {} as DynamicDialogRef;
  automationModelData : CustomAutomationData = {} as CustomAutomationData;
  selectedOwnershipType:any;
  filters: any[];
  selectedFilter: {name: string, value:string} | undefined;

  constructor(
    private store: Store,
    public translate: TranslateService,
    private router: Router,
    private campaignService: CampaignService,
    private dialogService: DialogService,
    private routeStateService:RouteStateService,
    private toastMessageService: ToastMessageService,
    private cd: ChangeDetectorRef
  ){
    this.filters = [
      {name: 'ALL', value:'all'},
      {name: 'ACTIVE',value:'active'},
      {name: 'INACTIVE',value:'inactive'},
      ];
  }

  ngOnInit(): void {
    this.showSkeleton$.next(true); 
    this.selectedFilter = this.filters.find(o => o.value == 'active');
    // this.Params.set('PageNumber', { name: 'PageNumber', value: 1 });
    // this.Params.set('PageSize', { name: 'PageSize', value: 10 });
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      this.tenantFranchiseId= tenant.selected_tenant.franchise_group_id;
      if (this.tenantId > 0) {
        this.tenant = tenant.selected_tenant;
        this.selectedOwnershipType = OwnershipLevel.Tenant;
        this.getCampaignList();
      }
    });
  }

    getCampaignList() {
      this.loading.next(true);
      this.campaignService.GetAutomationList(this.selectedOwnershipType,this.tenantId, this.tenantFranchiseId)
        .subscribe({
          next: (response: Automation[]) => {
            if (response) {
              const data = response.filter(o => (o.automation_event_type !== AutomationEventType.Campaign && o.automation_event_type.toString() !== AutomationEventType[AutomationEventType.Campaign]) && o.automation_is_webhook == false);
              const sortedData = data ? data.sort((a: { updated_date: string | number | Date; }, b: { updated_date: string | number | Date; }) => new Date(b.updated_date).getTime() - new Date(a.updated_date).getTime()) : [];
              if(this.selectedFilter?.value == 'all')
              {
                this.tableData.next(sortedData);
              }
              else
              {
                this.tableData.next(sortedData.filter(o => o.automation_status.toLowerCase() == this.selectedFilter?.value));
              }
              this.automationList.next(data);
              this.columnTranslate();
              this.loading.next(false);
              this.cd.detectChanges();
            } else {
              this.tableData.next([]);
              this.automationList.next([]);
              this.loading.next(false);
              this.cd.detectChanges();
            }
          },
          error: () => {
            this.tableData.next([]);
            this.loading.next(false);
          },
        });
    }

    SelectOwnership(ownershipType:OwnershipLevel)
    {
      this.selectedOwnershipType = ownershipType;
      this.getCampaignList();
    }

    columnTranslate() {
      this.translate
        .get([
          'CAMPAIGN.TABLE.AUTOMATION_NAME',
          'CAMPAIGN.TABLE.CREATED_ON',
          'CAMPAIGN.TABLE.CREATED_BY',
          'CAMPAIGN.TABLE.STATUS'
        ])
        .subscribe((translations) => {
          this.setColumnTranslate(translations);
        });
    }

    setColumnTranslate(translations: any) {
      const columns ={
        Name: translations['CAMPAIGN.TABLE.AUTOMATION_NAME'],
        CreatedOn: translations['CAMPAIGN.TABLE.CREATED_ON'],
        CreatedBy: translations['CAMPAIGN.TABLE.CREATED_BY'],
        Status: translations['CAMPAIGN.TABLE.STATUS'],
      };
      this.columns.next([
        {
          title: columns.Name,
          classes: ' py-2  white-space-nowrap relative font-bold ',
          sortable: true,
          filterable: true,
          dataProperty: 'automation_name',
          type: 'component',
          data: {
            name:CampaignNameComponent,
            fetch_key: 'automation_name',
            additionData: true,
            aData: {
              is_campaign:false,
              keyName: 'automation_name',
              keyName1: 'automation_description',
              keyName2: 'automation_event_type',
              uri: '/automation/edit-automation',
            },
          },
        },
        {
          title: columns.CreatedOn,
          classes: ' py-2  white-space-nowrap',
          sortable: true,
          filterable: true,
          dataProperty: 'created_date',
          type: 'component',
          data: {
            name: AgeCellComponent,
            additionData: true,
            aData: { fetch_key: 'created_date' },
          },
        },
        {
          title: columns.CreatedBy,
          classes: ' py-2  white-space-nowrap capitalize',
          sortable: true,
          filterable: true,
          dataProperty: 'created_by',
          type: 'component',
          data: { name: StaffInfoComponent },
        },
        {
          title: columns.Status,
          classes: 'py-2  white-space-nowrap',
          sortable: false,
          filterable: true,
          dataProperty: 'automation_status',
          type: 'component',
          data: {
            name: CampaignStatusComponent,
            additionData: true,
            aData: { fetch_key: 'automation_status',
            is_campaign:true },
          },
        },
        {
          title: '',
          classes: 'py-2  white-space-nowrap',
          sortable: false,
          filterable: true,
          dataProperty: 'automation_status',
          type: 'component',
          data: {
            name: CampaignStatusComponent,
            additionData: true,
            aData: { fetch_key: 'automation_status',
            is_campaign:false },
          },
        }
      ]);
    }

    fetchNextSetData(e: any) {
      this.Params.set('PageNumber', { name: 'PageNumber', value: e.pn });
      this.Params.set('PageSize', { name: 'PageSize', value: e.ps });
      this.getCampaignList();
    }

    filterData(event:any)
    {
      switch (event.value.value) {
        case 'all':
          this.tableData.next(this.automationList.value);
          break;
        case 'active':
          this.tableData.next(this.automationList.value.filter(o => o.automation_status.toLowerCase() == 'active'));
          break;
        case 'inactive':
          this.tableData.next(this.automationList.value.filter(o => o.automation_status.toLowerCase() == 'inactive'));
          break;
      }
    }

    get getParams(): Array<any> {
      return [...this.Params.values()];
    }

    get filteredData() {
      const tableData= this.tableData.value;
      return new BehaviorSubject(tableData.filter((item: { automation_name: string; }) =>
      item.automation_name.toLowerCase().includes(this.searchText.toLowerCase())
      ))
    }

    onActionEvent(event:any)
    {
      console.log(event);
      switch (event.action.toLowerCase()) {
        case 'active':
          this.campaignService.updateAutomationStatus(event.columnData.guid, 'active').subscribe({
            next: () => {
              this.translate.get('CAMPAIGN.MARK_AS_ACTIVE').subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
                this.getCampaignList();
              });
            }
          });
          break;
        case 'inactive':
          this.campaignService.updateAutomationStatus(event.columnData.guid, 'inactive').subscribe({
            next: () => {
              this.translate.get('CAMPAIGN.MARK_AS_INACTIVE').subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
                this.getCampaignList();
              });
            }
          });
          break;
      }
    }

    createAutomation() {
      const modelData: CustomAutomationData = {
        name: '',
        description: "",
        ownershiplevel: OwnershipLevel.Tenant,
        selectedCompanyTenants: [],
        selectedFrenchiseTenants: [],
        selectedFrenchise: null,
        companyId: 0,
        tenantId: 0,
        franchiseId:0,
        associatedStaff: false,
        additionalStaffTo: [],
        automationType: null,
        sqlRule: '',
        jsonRule: '',
        sqlQuery:'',
        formGroup: new UntypedFormGroup({}),
        event: "create",
        automationMaster: null,
        notificationSelected:false,
        staffNotificationForm: new UntypedFormGroup({}),
        actionsConfigured:false,
        dataChanged:false
      };
    
      this.refAutomationModal = this.dialogService.open(CustomAutomationPopupComponent, {
        showHeader: false,
        width: '90vw',
        height: 'auto',
        baseZIndex: 10000,
        maximizable: false,
        modal: true,
        dismissableMask: false,
        closable: true,
        data: modelData,
      });
    
      this.refAutomationModal.onClose.subscribe((res: any) => {
        if (res) {
          this.automationModelData = res;
          if (this.automationModelData.event == 'create') {
            // Open the second dialog when the first dialog closes
            this.refEventTrigeersModal = this.dialogService.open(SelectAutomationEventPopupComponent, {
              showHeader: false,
              width: '90vw',
              height: '80vh',
              baseZIndex: 10001,
              maximizable: false,
              modal: true,
              dismissableMask: false,
              closable: true,
              data: this.automationModelData, // Make sure to pass the correct data if needed
            });
    
            // Handle the onClose event of the second dialog
            this.refEventTrigeersModal.onClose.subscribe((secondDialogCloseRes: any) => {
              if (secondDialogCloseRes) {
                // Handle data or navigation after the second dialog closes
                if (this.automationModelData.event == 'create') {
                  this.routeStateService.setAutomationData(this.automationModelData);
                  this.router.navigate(['/automation/create-automation']);
                }
              }
              else {
                if (this.automationModelData.event == 'create') {
                    // If the user canceled the second dialog, reopen the first dialog
                    this.refAutomationModal = this.dialogService.open(CustomAutomationPopupComponent, {
                      showHeader: false,
                      width: '90vw',
                      height: 'auto',
                      baseZIndex: 10000,
                      maximizable: false,
                      modal: true,
                      dismissableMask: false,
                      closable: true,
                      data: modelData,
                    });
                }
              }
            });
          }
        }
      });
    }

    public get ownershipLevel()
    {
      return OwnershipLevel;
    }

}

